export function getFilterString(filters) {
    return Object.entries(filters)
        .map(([key, val]) => `${key}: ${typeof val === "string" ? `"${val}"` : val}`)
        .join(", ");
}
